import { BaseTempParams, ParsedPrizeImgMetadata } from "../types/componentTypes/prizeComponentTypes"

export interface CleanMetadataFuncParams {
    tempParams: BaseTempParams,
    langCode: string,
    objToClean: Record<string, ParsedPrizeImgMetadata[]>,
    defaultImgs: string[],
    existingMetadata: Record<string, ParsedPrizeImgMetadata[]>,
}

export const updateImgUrls = (url: string, formik, imgUrlsCopy: string[], lang?: string) => {
    if (imgUrlsCopy?.length !== 0) {
        const i = imgUrlsCopy.findIndex(imgUrl => imgUrl === url)
        imgUrlsCopy.splice(i, 1)
        const imagePersists = imgUrlsCopy.includes(url)
        if (!imagePersists) {
            if (lang) {
                const tempParamsImgUrlsCopy: Record<string, string[]> = formik.values.tempParams.img_url
                tempParamsImgUrlsCopy?.[lang]?.splice(tempParamsImgUrlsCopy?.[lang]?.indexOf(url), 1)
                const imagePersistsInTempParams = Object.values(tempParamsImgUrlsCopy)
                    ?.some((langUrlsArr) => langUrlsArr?.includes(url))
                if (imagePersistsInTempParams) return
            }
            const updatedImgUrls = formik.values?.img_url.filter((imgUrl: string) => imgUrl !== url)
            formik.setFieldValue('img_url', updatedImgUrls)
        } else {
            formik.setFieldValue('img_url', imgUrlsCopy)
        }
    }
}

export const updateTempParamsImgUrls = (formik, lang: string, url: string) => {
    const updatedTempParamsImgUrl = formik.values?.tempParams?.img_url?.[lang]
        ?.filter((imgUrl: string) => imgUrl !== url)
    const isTempParamsImgUrlForDel = updatedTempParamsImgUrl?.length === 0 ? undefined : updatedTempParamsImgUrl
    formik.setFieldValue(`tempParams.img_url.[${lang}]`, isTempParamsImgUrlForDel);
    return updatedTempParamsImgUrl
};

export const updateMetadataParams = (formik, lang: string, url: string) => {
    const langCodeMetadataObjArr = formik.values?.images_metadata?.[lang]
        ?.filter(obj => obj?.url !== url)
    const isLangCodeMetadataObjForDel = langCodeMetadataObjArr?.length === 0 ? undefined : langCodeMetadataObjArr
    formik.setFieldValue(`images_metadata[${lang}]`, isLangCodeMetadataObjForDel)
};
